import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const LEASING_COMMISSION_DELETED = gql`
  subscription leasingCommissionDeleted {
    leasingCommissionDeleted {
      commissionId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const LEASING_COMMISSION_SAVED = gql`
  subscription leasingCommissionSaved {
    leasingCommissionSaved {
      commissionId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
